/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useCurrentDoc } from 'docz'

import * as styles from './styles'
import { NavLink } from '~components/NavLink'
import { ChevronDown } from '~components/Icons'
import {useAuth0} from "@auth0/auth0-react";

export const NavGroup = ({ item, sidebarRef }) => {
    const currentDoc = useCurrentDoc()
    const currentDocRef = React.useRef()
    const { name, menu } = item
    const [subheadingsVisible, setShowsubheadings] = React.useState(
        currentDoc.menu === name
    )

    const { user } = useAuth0();

    // Retrieve a list of roles.
    const { 'https://www.citnow.com/role' : assignedRoles } = user;

    const toggleSubheadings = () => setShowsubheadings(!subheadingsVisible)
    React.useEffect(() => {
        if (sidebarRef.current && currentDocRef.current) {
            sidebarRef.current.scrollTo(0, currentDocRef.current.offsetTop)
        }
    }, [sidebarRef])

    let numberItems = 0;
    menu.map(menu => {
        // Check if the role is assigned to the logged in user.
        if(menu.role && assignedRoles.indexOf(menu.role) >= 0)
            numberItems++;
        return;
    });

    if(numberItems === 0) return null;

    return (
        <div sx={styles.wrapper} data-testid="nav-group">
            <div sx={styles.title({active: subheadingsVisible})} onClick={toggleSubheadings}>
                {item.name}
                <ChevronDown sx={styles.chevron({ active: subheadingsVisible })} />
            </div>
            <div sx={styles.sublinkWrapper} data-testid="nav-group-links">
                {menu &&
                subheadingsVisible &&
                menu.sort((a, b) => a.index - b.index).map(menu => {
                    // Check if the role is assigned to the logged in user.
                    if(menu.role && assignedRoles.indexOf(menu.role) === -1)
                        return null;
                    if (currentDoc.route === menu.route) {
                        return (
                            <NavLink key={menu.id} item={menu} ref={currentDocRef}>
                                {menu.name}
                            </NavLink>
                        )
                    }
                    return (
                        <NavLink key={menu.id} item={menu}>
                            {menu.name}
                        </NavLink>
                    )
                })}
            </div>
        </div>
    )
}